// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2833":"417e1c94","2975":"87339193","6533":"f001b1dd","8303":"41c5f037"}[chunkId] + ".chunk.css";
};